export interface Article {
  id: string;
  headline: string;
  subheading: string;
  content: string;
  html_content: string;
  news_source: string;
  news_url: string;
  all_sources?: { name: string; url: string }[];
  status: string;
  style_match_score: number;
  feedback: string;
  imageUrl?: string;
  workflow_id?: string;
  revision_count?: number;
  last_revised?: string;
  original_headline?: string;
  revision_history?: Array<{
    timestamp: string;
    feedback: string;
    previous_headline?: string;
    previous_subheading?: string;
    previous_content?: string;
    revised_headline?: string;
    revised_subheading?: string;
    revised_content?: string;
    model_used?: string;
  }>;
  created_at?: string;
  plagiarism_score?: number;
  originality_score?: number;
  style_compliance_score?: number;
  plagiarism_details?: string;
  generated_image_url?: string;
  image_prompt?: string;
  image_generation_status?: string;
  image_confidence_score?: number;
  style_breakdown?: StyleBreakdown;
  style_feedback?: string[];
  style_status?: string;
  confidence_score?: number;
  category?: string;
  sub_vertical?: string;
  tags?: string[];
}

export interface StyleBreakdown {
  structure?: number;
  terminology?: number;
  data_presentation?: number;
  tone_style?: number;
  coherence?: number;
}

export interface AgentStatus {
  status: 'idle' | 'processing' | 'completed' | 'error';
  progress: number;
  message: string;
}

export interface Source {
  name: string;
  category: string;
  url: string;
  country: string;
  flag: string;
  enabled: boolean;
  is_custom: boolean;
}

export interface RevisionHistoryEntry {
  timestamp: string;
  feedback: string;
  previous_content: string;
  revised_content: string;
}

export interface RevisionHistory {
  headline: string;
  revision_count: number;
  last_revised: string;
  revision_history: RevisionHistoryEntry[];
}

export interface AgentNode {
  id: string;
  name: string;
  shortName: string;
  status: 'idle' | 'active' | 'completed' | 'error' | 'streaming' | 'standby' | 'queued';
  description: string;
  engine?: string;
  metrics?: string;
}

export const CATEGORY_LABELS: Record<string, string> = {
  'bauxite': 'Bauxite',
  'alumina': 'Alumina',
  'primary-aluminium': 'Primary AL',
  'downstream-products': 'Downstream',
  'end-user': 'End User',
  'recycled-aluminium': 'Recycled AL',
  'sustainability': 'Sustainability',
  'supplement-aluminium': 'SupplementAL',
};
